module.exports = __webpack_public_path__ + "img/lipi-logo.95110dc6.png";